/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { DocumentSelectCard } from "cms/documents/document-selector/display/document-select-card";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";
import { DocumentInfoCard } from "cms/documents/document-selector/display/document-info-card";
import { objectHasPropertyString } from "utils/empty-exists";

const DefaultDocumentSelectorDisplayComponent = () => {

    const {
        onChange,
        onEdit,
        onRemove,
        document
    } = useContext(DocumentEditContext);

    const { t } = useTranslation();
    const style = "field.style.body";
    const format = "field.format.document-card-icon";
    const options = { openIn: "tab" };

    const onChangeDocument = () => {
        onChange(document);
    };
    const onEditDocument = () => {
        onEdit(document);
    };
    const onRemoveDocument = () => {
        onRemove(document);
    };

    return (
        <Fragment>
            {objectHasPropertyString(document,"url") &&
                <Fragment>
                    <div
                        className='document-selector-container'
                        onClick={() => onChange(document)}
                    >
                        <DocumentSelectCard
                            document={document.guid}
                            style={style}
                            format={format}
                            options={options}
                            // onClick={onChange}
                        />
                    </div>
                    <div className='document-selector-infobox-container'>

                        <DocumentInfoCard />

                        <Button
                            variant='text'
                            onClick={onEditDocument}
                        >
                            {t("commons.edit")}
                        </Button>

                        <Button
                            variant='text'
                            onClick={onChangeDocument}
                        >
                            {t("commons.change")}
                        </Button>

                        <Button
                            variant='text'
                            onClick={onRemoveDocument}
                            // startIcon={<CloseIcon />}
                        >
                            {t("commons.remove")}
                        </Button>

                    </div>
                </Fragment>
            }
        </Fragment>
    );
};

export { DefaultDocumentSelectorDisplayComponent };
